/**
 * [@param](/user/param)  {Function}
 * [@param](/user/param)  {[Function]}  延时调用函数
 * [@param](/user/param)  {[Number]}  延迟多长时间
 * [@return](/user/return) {[Number]}  至少多长时间触发一次
 */

// eslint-disable-next-line no-unused-vars
export function throttle (fn, delay, mustRun) {
  // eslint-disable-next-line one-var
  let timer = null,
    previous = null

  return function () {
    // eslint-disable-next-line one-var
    let now = +new Date(),
      context = this,
      args = arguments
    if (!previous) previous = now
    let remaining = now - previous
    if (mustRun && remaining >= mustRun) {
      fn.apply(context, args)
      previous = now
    } else {
      clearTimeout(timer)
      timer = setTimeout(function () {
        fn.apply(context, args)
      }, delay)
    }
  }
}

export function debounce (fn, wait) {
  let callback = fn
  let timerId = null

  function debounced () {
    let context = this
    let args = arguments

    clearTimeout(timerId)
    timerId = setTimeout(function () {
      callback.apply(context, args)
    }, wait)
  }
  return debounced
}
